import service from "@/router/axios";

// 添加Dsp链接信息
export const addLink = (data) => {
  return service({
    url: 'dsp/link/addLink',
    method: 'post',
    data
  })
}

export const updateLink = (data) => {
  return service({
    url: 'dsp/link/updateLink',
    method: 'PUT',
    data
  })
}

// 获取Dsp链接信息名称
export const getLinkName = (params) => {
  return service({
    url: 'dsp/link/getLinkName',
    method: 'get',
    params
  })
}

export const deleteLink = (params) => {
  return service({
    url: 'dsp/link/delete/'+ params,
    method: 'delete'
  })
}

export const addMonitor = (data) => {
  return service({
    url: 'channel/monitor/addMonitor',
    method: 'post',
    data
  })
}

export const updateMonitor = (data) => {
  return service({
    url: 'channel/monitor/updateMonitor',
    method: 'PUT',
    data
  })
}

// 获取Dsp链接信息名称
export const getMonitorName = (params) => {
  return service({
    url: 'channel/monitor/getMonitorName',
    method: 'get',
    params
  })
}

export const deleteMonitor = (params) => {
  return service({
    url: 'channel/monitor/delete/'+ params,
    method: 'delete'
  })
}


